// extracted by mini-css-extract-plugin
export default {"dimension":"AHnj3","parameter":"M7evG","hardness":"ZLsFV"};